export default {
    setMessage(state, myMessage) {
        state.myMessage = myMessage;
    },
    clearMessage(state) {
        state.myMessage = null;
    }
}